/**
 * Resolves media URLs (logos, signatures, invoice photos) to work seamlessly
 * across all domains, IP addresses, PWA mobile mode, and environments.
 * If given a relative URL (e.g. /static/logos/foo.png), returns it as-is so
 * the browser loads it from the current origin ('self').
 * If given an absolute URL that points to /static/..., converts it to a relative
 * URL so Content Security Policy (img-src 'self') and HTTPS certificates never fail.
 */
export const resolveMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const parsed = new URL(trimmed);
      if (parsed.pathname.startsWith('/static/')) {
        return parsed.pathname;
      }
      return trimmed;
    } catch {
      return trimmed;
    }
  }
  if (!trimmed.startsWith('/')) {
    return `/${trimmed}`;
  }
  return trimmed;
};

export default resolveMediaUrl;
